import React from "react";

import cx from "classnames";

import styles from "./Button.module.css";

export type ButtonProps = React.HTMLProps<HTMLButtonElement> &
	React.ButtonHTMLAttributes<HTMLButtonElement> & {
		primary?: boolean;
	};

/**
 * This is our button. There are many like it, but this one is ours.
 *
 * @todo The translation from props to classNames is pretty clumsy—
 *	we should figure out something nicer and more reusable.
 */

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
	const { className, primary, children, ...rest } = props;

	const styleProps = {
		[styles.primary]: primary,
	};

	return (
		<button ref={ref} {...rest} className={cx(styles.button, className, styleProps)}>
			{children}
		</button>
	);
});

Button.displayName = "Button";

export default Button;
